import { Checkbox, ListItemText } from '@mui/material'
import { Fragment } from 'react'

type MenuItemValueProps = {
  label: string
  multiple: boolean | undefined
  selected: string[]
}

export default function MenuItemValue({ label, multiple, selected }: MenuItemValueProps) {
  if (!multiple) return <Fragment>{label}</Fragment>
  return (
    <Fragment>
      <Checkbox checked={selected.includes(label)} />
      <ListItemText primary={label} />
    </Fragment>
  )
}
